// extracted by mini-css-extract-plugin
module.exports = {"RemoveFilterButton":"RemoveFilterButton_RemoveFilterButton__2iCnn"};